import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { showAssignRoleDrawer } from "views/Account/Settings/User/AssignRoleDrawer";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import useCanManageUsers from "shared/User/access/useCanManageUsers";
import { getCanRevokeUserAccess } from "views/Account/Settings/helpers";

import { showUserListRevokeAccessConfirmation } from "./ConfirmationModal";
import styles from "./styles.module.css";
import { UsersListUser } from "../../types";

type UsersListItemDropdownProps = {
  handleUserDetailsClick: (details: UsersListUser) => unknown;
  item: UsersListUser;
};

const UsersListItemDropdown = ({ handleUserDetailsClick, item }: UsersListItemDropdownProps) => {
  const { viewer } = useTypedContext(AccountContext);
  const canManageUsers = useCanManageUsers();

  const confirmationModalShow = () => {
    showUserListRevokeAccessConfirmation({
      id: item.id,
      userName: item.username,
    });
  };

  const handleAccessDetailsClick = () => {
    handleUserDetailsClick(item);
  };

  const assignRoles = () => {
    showAssignRoleDrawer({ userId: item.id });
  };

  const canRevokeAccess = getCanRevokeUserAccess({ canManageUsers, viewer, user: item });

  return (
    <div className={styles.wrapper}>
      <DropdownMenuEllipsis tooltip="User actions">
        <DropdownMenuItem onAction={handleAccessDetailsClick}>See details</DropdownMenuItem>
        <DropdownMenuItem
          analyticsPage={AnalyticsPageOrganization.OrganizationUsers}
          analyticsTitle="Manage Roles Clicked"
          onAction={assignRoles}
        >
          Manage roles
        </DropdownMenuItem>

        {canRevokeAccess && (
          <DropdownMenuItem danger onAction={confirmationModalShow}>
            Revoke access
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </div>
  );
};

export default UsersListItemDropdown;
